import { render, staticRenderFns } from "./StockHistoryView.vue?vue&type=template&id=1437edd9&scoped=true"
import script from "./StockHistoryView.vue?vue&type=script&lang=js"
export * from "./StockHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437edd9",
  null
  
)

export default component.exports